import * as api from '../api/index'
import { FETCH_ORDERS_BY_USER, FETCH_ORDER, FETCH_DELETED_ORDERS, UPSERT_ORDER, UPDATE_ORDER, DELETE_ORDER, RESTORE_ORDER, PERMANENT_DELETE_ORDER, START_LOADING, END_LOADING } from './constants'

export const getOrdersByUser = (searchQuery) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING })
    const { data: { data } } = await api.fetchOrdersByUser(searchQuery || {})
    dispatch({ type: FETCH_ORDERS_BY_USER, payload: data || [] })
  } catch (error) {
    console.log(error?.response || error)
  } finally {
    dispatch({ type: END_LOADING })
  }
}

export const getOrder = (id) => async (dispatch) => {
  try {
    const { data } = await api.fetchOrder(id)
    dispatch({ type: FETCH_ORDER, payload: data })
  } catch (error) {
    console.log(error?.response || error)
  }
}

export const upsertOrderFromInvoice = (invoice) => async (dispatch) => {
  if (!invoice) return
  try {
    const { data } = await api.upsertOrderFromInvoice(invoice)
    if (data?.deletedAt) return
    dispatch({ type: UPSERT_ORDER, payload: data })
  } catch (error) {
    console.log(error?.response || error)
  }
}

export const updateOrder = (id, updates, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateOrder(id, updates)
    dispatch({ type: UPDATE_ORDER, payload: data })
    openSnackbar && openSnackbar('Order updated')
  } catch (error) {
    console.log(error?.response || error)
  }
}

export const deleteOrder = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteOrder(id)
    dispatch({ type: DELETE_ORDER, payload: id })
    openSnackbar && openSnackbar('Order moved to Recently Deleted')
  } catch (error) {
    console.log(error?.response || error)
    openSnackbar && openSnackbar('Unable to delete order')
  }
}

export const getDeletedOrders = () => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING })
    const { data: { data } } = await api.fetchDeletedOrders()
    dispatch({ type: FETCH_DELETED_ORDERS, payload: data || [] })
  } catch (error) {
    console.log(error?.response || error)
  } finally {
    dispatch({ type: END_LOADING })
  }
}

export const restoreOrderById = (id, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.restoreOrder(id)
    dispatch({ type: RESTORE_ORDER, payload: data })
    openSnackbar && openSnackbar('Order restored')
  } catch (error) {
    console.log(error?.response || error)
  }
}

export const deleteOrderPermanentById = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteOrderPermanent(id)
    dispatch({ type: PERMANENT_DELETE_ORDER, payload: id })
    openSnackbar && openSnackbar('Order deleted permanently')
  } catch (error) {
    console.log(error?.response || error)
  }
}
